import type { TFunction } from "i18next";

import type { ChangeTold } from "shared/api/types";

/**
 * Round 19 N12 -- the sentence a raise adds when it fired a watched rule:
 * how many people were told now, and that the rest of the seat is told
 * at their own first sign-in. Empty when no rule fired. Shared by the
 * change register and the regulatory-change door, which both raise.
 */
export function toldSentence(
  t: TFunction,
  told: ChangeTold | null | undefined,
): string {
  if (!told || told.rules_fired === 0) return "";
  if (told.reached === 0) return t("modules.twin.changes.toldNobodyYet");
  return t("modules.twin.changes.toldNow", { count: told.reached });
}
